module.exports = __webpack_public_path__ + "img/fat-free-biscuits.a4659b8a.jpg";